import type {
  AssigneesByType,
  GranularTaskAssignmentsType,
  RawAssigneesType,
} from './types';
import type {
  TaskAssignmentSerializedType,
  TaskAssignmentWriteSerializedType,
} from 'sweet-types';

export function globalAssigneesToRawAssignees(
  global: AssigneesByType
): RawAssigneesType {
  const rawAssignees: RawAssigneesType = {
    user_ids: [],
    team_ids: [],
    role_ids: [],
  };

  if ((global.users?.length ?? 0) > 0) {
    rawAssignees.user_ids = global.users!.map((u) => u.url);
  }
  if ((global.roles?.length ?? 0) > 0) {
    rawAssignees.role_ids = global.roles!.map((r) => r.url);
  }
  if ((global.teams?.length ?? 0) > 0) {
    rawAssignees.team_ids = global.teams!.map((t) => t.url);
  }

  return rawAssignees;
}

export function granularAssigneesToRawAssignees(
  granular: GranularTaskAssignmentsType | Array<TaskAssignmentSerializedType>
): Array<TaskAssignmentWriteSerializedType> {
  return granular.map((a) => {
    // convert LaneSerialized object to lane hashid
    if (a.lane != null && typeof a.lane !== 'string') {
      a = {...a, lane: a.lane.hashid};
    }

    if (a.user != null) {
      return {...a, user: a.user.url};
    } else if (a.team != null) {
      return {...a, team: a.team.url};
    } else {
      return {...a, role: a.role.url};
    }
  });
}
